import React, { lazy } from "react";
import SubscribePage from "../components/SubscribePage/SubscribePage";
import HomePage from "../pages/HomePage/HomePage";
import CountryPage from "../components/CountryPage/CountryPage";
import LoyaltyPage from "../components/LoyaltyProgram/LoyaltyPage/LoyaltyPage";
import MembershipApplication from "../components/MembershipApplic/MembershipApplication";
import B2BSection from "../components/B2B/B2BSection/B2BSection";
import B2BCorporatePaymentsPage from "../components/B2B/B2BCorporatePayments/B2BCorporatePaymentsPage";
import B2BBrandPerceptionPage from "../components/B2B/B2BBrandPerception/B2BBrandPerceptionPage";
import B2BContactPage from "../components/B2B/B2BContact/B2BContactPage";
import ContactUs from "../components/ContactUs/ContactUs";
import AssociatedMembers from "../components/AssociatedMembers/AssociatedMembers";
import { CulturalEventsPage } from "../components/CulturalEvents/Public/CulturalEventsPage";
import { EventDetailPage } from "../components/CulturalEvents/Public/EventDetailPage";
import B2BToGcbRedirect from "./B2BToGcbRedirect";

// Lazy loaded components for better performance
const FlagGrid = lazy(() => import("../components/FlagGrid/FlagGrid"));
const AboutUs = lazy(() => import("../components/AboutUs/AboutUs"));
const OurRules = lazy(() => import("../components/OurRules/OurRules"));
const PrivacyPolicy = lazy(
  () => import("../components/PrivacyPolicy/PrivacyPolicy")
);
const TermsOfUse = lazy(() => import("../components/TermsOfUse/TermsOfUse"));

/**
 * Public routes configuration
 * Routes accessible without authentication
 */
export const publicRoutes = [
  {
    path: "/",
    element: <HomePage />,
  },
  {
    path: "/subscribe",
    element: <SubscribePage />,
  },
  {
    path: "/country/:countryName",
    element: <CountryPage />,
  },
  {
    path: "/loyalty-program/*",
    element: <LoyaltyPage />,
  },
  {
    path: "/aboutUs",
    element: <AboutUs />,
  },
  {
    path: "/ourCountries",
    element: <FlagGrid />,
  },
  {
    path: "/ourRules",
    element: <OurRules />,
  },
  {
    path: "/membershipApplication",
    element: <MembershipApplication />,
  },
  {
    path: "/b2b",
    element: <B2BToGcbRedirect />,
  },
  {
    path: "/gcb",
    element: <B2BSection />,
  },
  {
    path: "/b2b/corporate-payments",
    element: <B2BToGcbRedirect />,
  },
  {
    path: "/gcb/corporate-payments",
    element: <B2BCorporatePaymentsPage />,
  },
  {
    path: "/b2b/brand-perception",
    element: <B2BToGcbRedirect />,
  },
  {
    path: "/gcb/brand-perception",
    element: <B2BBrandPerceptionPage />,
  },
  {
    path: "/b2b/contact",
    element: <B2BToGcbRedirect />,
  },
  {
    path: "/gcb/contact",
    element: <B2BContactPage />,
  },
  {
    path: "/privacyPolicy",
    element: <PrivacyPolicy />,
  },
  {
    path: "/termsOfUse",
    element: <TermsOfUse />,
  },
  {
    path: "/contactUs",
    element: <ContactUs />,
  },
  {
    path: "/associatedMembers",
    element: <AssociatedMembers />,
  },
  {
    path: "/cultural-events",
    element: <CulturalEventsPage />,
  },
  {
    path: "/cultural-events/:id",
    element: <EventDetailPage />,
  },
];
